

























































import {Component, Vue} from "vue-property-decorator";
import SearchBox from "@/components/SearchBox.vue";
import VueError from "@/components/VueError.vue";
import PageNav from "@/components/PageNav.vue";
import Loading from "@/components/Loading.vue";
import NavBar from "@/components/NavBar.vue";
import NtagLocationRow from '@/components/ntag/NtagLocationRow.vue';
import {DateTime} from "luxon";
import {curPref} from "@/services/Preferences";
import {NTag, NTagLocation} from "@/types/ntag";
import {curNtagClient, NtagClient} from "@/services/NtagClient";
import * as _ from "lodash";
import moment from "moment";
import fileDownload from "js-file-download";

@Component({
  components: {
    NtagLocationRow,
    SearchBox,
    VueError,
    PageNav,
    Loading,
    NavBar
  },
})
export default class NtagLocations extends Vue {
  // our model
  dateTime = DateTime;
  curOrderBy = curPref.retrieve('v3-ntag-tags-cur-order', 'location.name');
  curAscDesc = curPref.retrieve('v3-ntag-tags-cur-asc-desc', 'asc');
  searchTerm = curPref.retrieve('v3-ntag-tags-search-term', '');
  pageSize = 20;
  error:string = '';
  httpBusy:boolean = false;
  locations:NTagLocation[] = [];

  // internal dependencies
  private ntagClient:NtagClient = curNtagClient;

  async mounted() {
    this.refreshData();
  }

  async refreshData() {

    this.httpBusy = true;

    const reply = await this.ntagClient.getLocations();

    this.httpBusy = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to load locations because ${reply.errorMsg}`;

    this.locations = this.sortLocations(_.filter(reply.locations, loc => !loc.hidden));
  }

  sortLocations(locations: NTagLocation[]): NTagLocation[] {
    return _.orderBy(locations, [this.curOrderBy], [this.curAscDesc]);
  }

  newOrderBy(newOrderBy:{orderBy:string, ascDesc:string}) {

    curPref.store('v3-ntag-locations-cur-order', newOrderBy.orderBy);
    curPref.store('v3-ntag-locations-cur-asc-desc', newOrderBy.ascDesc);

    this.curOrderBy = newOrderBy.orderBy;
    this.curAscDesc = newOrderBy.ascDesc;

    this.refreshData();
  }

  newSearchText(newSearchText:string) {

    curPref.store('v3-ntag-locations-search-term', newSearchText);
    this.searchTerm = newSearchText;
    this.refreshData();
  }

  get showSearchBox():boolean {
    return false;
    // return this.probeList.length > 0 || this.searchTerm !== '';
  }

  /*get showPageNav():boolean {
    return this.pageList.length > 0;
  }*/

  async exportLocations() {
    const csvExport = this.locationsToCSV(this.locations);

    const filename = `export-locations-${moment().toISOString(true)}.csv`;

    fileDownload(csvExport, filename);
  }

  private locationsToCSV(locations: NTagLocation[]): string {
    const retList:string[] = [];

    retList.push(`location,baseStations,enterpriseId,numberOfTags`);

    for(const location of locations) {

      const row = [];
      row.push(this.forceString(location.name as string));
      row.push(this.forceString(location.bssIdsList.join('|')));
      row.push(this.forceString(location.enterpriseId.replace(/^nnn\./, '')));
      row.push(location.numberOfTags ? location.numberOfTags : '');

      retList.push(row.join(','));
    }

    return retList.join("\n");
  }

  private forceString(data:string):string {
    return `"${data}"`;
  }

  get showDeviceRows():boolean {
    return !this.httpBusy && this.locations.length > 0;
  }

  get showNoMatches():boolean {
    return !this.httpBusy && this.locations.length === 0 && this.searchTerm !== '';
  }

  get showNoLocations():boolean {
    return !this.httpBusy && this.locations.length === 0 && this.searchTerm === '';
  }
}
